var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "35px",
    viewBox: "0 0 24 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DB019004-761A-47AF-85F5-F2BCD8B20164@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aa",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login-States",
    transform: "translate(-1103.000000, -133.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login-form-Copy-2",
    transform: "translate(924.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(155.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-desktop",
    transform: "translate(24.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EF0F0F",
    x: 4.23529412,
    y: 29.4,
    width: 16.9411765,
    height: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L7.12562628,0 L10.2030061,11.2290142 C10.8309519,13.5796863 11.4544442,16.0769978 12.0779365,18.5698656 L12.2738913,18.5698656 C12.8483949,16.0769978 13.4763407,13.5796863 14.099833,11.2290142 L17.2172945,0 L24,0 L16.2063463,23.8 L8.01632956,23.8 L0,0 Z",
    id: "Path",
    fill: "#0070CD"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logo-blue.da29f60b2838ac93e32fbf8c3eb87341.svg";
export { ForwardRef as ReactComponent };